export const Marquee = ({ items = [], speed = "slow", variant = "outline" }) => {
    const cls = speed === "slow" ? "animate-marquee-slow" : "animate-marquee";
    const line = [...items, ...items];
    return (
        <div className="relative overflow-hidden py-10 border-y border-white/10" data-testid="marquee">
            <div className={`flex whitespace-nowrap ${cls}`}>
                {line.map((item, i) => (
                    <span
                        key={i}
                        className={`font-editorial italic text-[11vw] leading-none pr-16 ${
                            variant === "outline"
                                ? "text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.35)]"
                                : "text-white/20"
                        }`}
                    >
                        {item} <span className="text-edge not-italic">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
};

export default Marquee;
